export function parsePrice(value: string | number | undefined | null) {
  if (typeof value === "string") {
    value = parseFloat(value);
  }
  if (value === undefined || value === null) {
    return null;
  }
  if (isNaN(value)) {
    value = null;
  }
  return value ?? null;
}
